import { render, staticRenderFns } from "./CAAG1040.vue?vue&type=template&id=796ac31e&scoped=true"
import script from "./CAAG1040Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1040Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1040.vue?vue&type=style&index=0&id=796ac31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ac31e",
  null
  
)

export default component.exports